import { buildDataLayerBaseProductList, buildDataLayerProductList, buildDataLayerSearch, buildDataLayerShopList, buildDataLayerBaseShopList, } from '../DataLayerUtils';
export default class DataLayerBaseEvent {
    updateDataLayer(tms, eventType, eventName, eventData, errorHandler) {
        try {
            tms.updateDataLayer(eventType, eventName, eventData);
        }
        catch (error) {
            errorHandler(error);
        }
    }
    getPropertyData(searchCriteria, searchData, pageSize, propertyCode) {
        const dataLayerProductList = buildDataLayerProductList({
            searchCriteria,
            pageSize,
            searchData,
            propertyCode,
        });
        const dataLayerSearch = buildDataLayerSearch({
            searchCriteria,
        });
        const dataLayerShopList = buildDataLayerShopList({
            searchCriteria,
            searchData,
        });
        return {
            ...dataLayerProductList,
            ...dataLayerSearch,
            ...dataLayerShopList,
        };
    }
    getBasePropertyData(searchCriteria, searchData, propertyCode) {
        const dataLayerMapProductList = buildDataLayerBaseProductList({
            searchCriteria,
            searchData,
            propertyCode,
        });
        const dataLayerSearch = buildDataLayerSearch({
            searchCriteria,
        });
        const dataLayerShopList = buildDataLayerBaseShopList({
            searchCriteria,
            searchData,
        });
        return {
            ...dataLayerMapProductList,
            ...dataLayerSearch,
            ...dataLayerShopList,
        };
    }
}
//# sourceMappingURL=DataLayerBaseEvent.js.map